/* eslint-disable camelcase */
import { getMaker } from 'src/uses/ajax/getMaker'
import { getModel } from 'src/uses/ajax/getModel'
import { getPastrecommend } from 'src/uses/ajax/getPastrecommend'
import { getBrand } from 'src/uses/ajax/getBrand'
import { getJudgment } from 'src/uses/ajax/getJudgment'
import { getTire } from 'src/uses/ajax/getTire'
import { getQuestion } from 'src/uses/ajax/getQuestion'
import { getDashboard } from 'src/uses/ajax/getDashboard'

import { setResponse } from 'src/modules/result'
import { setMaintenance, setShopQrUnknowID } from 'src/modules/status'

import { talkMessage } from 'src/scripts/utilities'

type TProps = {
  name?: 'question' | 'maker' | 'model' | 'tire' | 'judgment' | 'pastrecommend' | 'brand' | 'dashboard',
  question_process_id?: '',
  form_type?: string,
  form_id?: string,
  answer_id1?: string,
  answer_id2?: string,
  answer_id3?: string,
  recommend_result_id?: string
}

export const Ajax = (props:TProps) => {
  if (!props.name) { return }
  const GET_LIST = {
    maker: getMaker,
    model: getModel,
    tire: getTire,
    judgment: getJudgment,
    pastrecommend: getPastrecommend,
    brand: getBrand,
    question: getQuestion,
    dashboard: getDashboard
  }
  const REQ = GET_LIST[props.name]

  return async (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const STATE = getState()
      REQ(STATE, props, resolve, reject)
    }).then((result:any) => {
      // NOTE: maker/brandなどのAPI処理にてREQ内でstatusを削っているためlengthも判断基準に
      if (result.length || result?.status?.match(/^success$/i)) { return result }

      // NOTE: 表示用エラーレスポンス格納
      result && dispatch(setResponse(result))

      // NOTE: エラー処理
      switch (result?.errorCode) {
        // NOTE: システムエラー @ai server
        case 10101001:
        case 10101002:
        case 20101001:
        case 20102001:
        case 30101002:
          result.errorMessage && talkMessage({
            iterator: 0,
            id: 'system_error',
            text: result.errorMessage,
            data: {
              custom: 'error_reset',
              questions: [
                {
                  text: '最初から診断する',
                  value: '1'
                }
              ]
            }
          }, getState(), dispatch)
          break
        // NOTE: メンテナンス @ai server
        case 30101001:
          dispatch(setMaintenance(true))
          break
        // NOTE: SHOP_QR noID @api server
        case 40104001:
          dispatch(setShopQrUnknowID(true))
          break
        // NOTE: 汎用エラー @api server
        default:
          result.errorMessage && talkMessage({
            iterator: 0,
            id: 'system_error',
            text: '現在システムが混み合っております。しばらく時間をおいてからやり直してください。',
            data: {
              custom: 'error_reset',
              questions: [
                {
                  text: '最初から診断する',
                  value: '1'
                }
              ]
            }
          }, getState(), dispatch)
          break
      }
    })
  }
}
